import { Link } from 'react-router-dom';
import { useUserPageContextValueHook } from '../../contexts/UserPageContextProvider';
import { useAuthContextValueHook } from '@/contexts/AuthContext';

const PAGE_CLIENT_URL = process.env.REACT_APP_PAGE_CLIENT_URL;

export function TopNavBar(props) {
    const authContextValueHook = useAuthContextValueHook();
    const userPageContextValueHook = useUserPageContextValueHook();
    const userPage = userPageContextValueHook?.userPage;

    return (
        <header className="sticky top-0 z-[100] border-b border-black/[0.06] bg-white/80 backdrop-blur-xl">
            <div className="flex h-14 items-center justify-between px-4 sm:px-6">
                <div className="flex items-center gap-1 sm:gap-3">
                    <a href={PAGE_CLIENT_URL} className="flex items-center gap-2 pr-2" aria-label="슈룩 홈">
                        <img src="/assets/images/shooluk_logo.png" alt="" className="h-8 w-8 rounded-full" />
                        <span className="hidden text-[17px] font-extrabold tracking-tight text-gray-900 sm:inline">shool<span className="text-[var(--mainColor)]">.</span>uk</span>
                    </a>
                    {!userPageContextValueHook?.isLoading && (
                        userPage
                            ? <Link to={`/mypage/${userPage.id}`} className="rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-800 hover:bg-black/5">마이 페이지</Link>
                            : <Link to='/create/mypage' className="rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-800 hover:bg-black/5">페이지 생성</Link>
                    )}
                </div>

                <div className="flex items-center gap-2">
                    {!authContextValueHook?.isReady
                        ? <span className="h-8 w-8 animate-pulse rounded-full bg-gray-100" />
                        : authContextValueHook?.isLoggedIn
                            ? <Link to='/profile' aria-label="내 정보" className="flex h-9 w-9 items-center justify-center rounded-full hover:bg-black/5">
                                <img src='/assets/icons/profile_circle_000000.svg' alt="" className="h-7 w-7 opacity-80" />
                            </Link>
                            : <Link to='/login' className="rounded-full bg-gray-900 px-4 py-1.5 text-sm font-semibold text-white hover:bg-gray-700">로그인</Link>
                    }
                </div>
            </div>
        </header>
    );
}
